import { Link } from 'react-router-dom';

import { Button } from 'primereact/button';

const SidebarFooter = (props: { minimized: boolean }): JSX.Element => {
  const { minimized } = props;

  return (
    <section className="overflow-hidden p-4">
      {!minimized && (
        <Link to="/docs-and-components">
          <Button className="bg-transparent border-primary-500" label="Documents and Components" />
        </Link>
      )}
    </section>
  );
};

export default SidebarFooter;
